import { Component, Input, Output, EventEmitter } from '@angular/core';
import type { OnInit } from '@angular/core';
import { App_ListeOption } from 'src/app/utils/interfaces';

@Component({
  selector: 'app-c-typeahead',
  templateUrl: './c-typeahead.component.html',
  styleUrls: ['./c-typeahead.component.scss'],
})
export class CTypeaheadComponent implements OnInit {
  @Input() items: App_ListeOption[] = [];
  @Input() selectedItem: number | string | null = null;
  @Input() title: string | undefined = '';

  @Output() selectionCancel = new EventEmitter<void>();
  @Output() selectionChange = new EventEmitter<number | string | null>();

  filteredItems: App_ListeOption[] = [];
  workingSelectedValue: number | string | null = null;


  constructor() { }

  ngOnInit() {
    this.filteredItems = [...this.items];
    this.workingSelectedValue = this.selectedItem;
  }

  trackItems(index: number, item: App_ListeOption) {
    return item.value;
  }

  cancelChanges() {
    this.selectionCancel.emit();
  }

  confirmChanges() {
    this.selectionChange.emit(this.workingSelectedValue);
  }

  searchbarInput(ev: any) {
    this.filterList(ev.target.value);
  }

  filterList(searchQuery: string | undefined) {
    if (searchQuery === undefined) {
      this.filteredItems = [...this.items];
    } else {
      const normalizedQuery = searchQuery.toLowerCase();
      this.filteredItems = this.items.filter((item) => {
        return item.label.toLowerCase().includes(normalizedQuery);
      });
    }
  }

  isChecked(value: number | string) {
    return this.workingSelectedValue === value;
  }

  checkboxChange(ev: any) {
    const { checked, value } = ev.detail;

    if (checked) {
      this.workingSelectedValue = value;
    } else {
      this.workingSelectedValue = null;
    }
  }

}
